module.exports = __webpack_public_path__ + "img/ic_slack.1f0def6d.png";